import React from 'react'
import './style.css'
import {
    Button,
    Grid,
    Typography,
    TextField,
    Card,
    CardContent,
} from "@material-ui/core";
import { useHistory } from 'react-router-dom'
import axiosInstance from '../../../environment/axiosInstances'
import * as popUpActionCreator from "../../../store/Actions/popup-actionCreator";
import { connect } from "react-redux";
import { fontStyle, padding } from '@mui/system';
import { useStyles } from '../styles';

const formGroup: any = [
    {
        field: 'email',
        valid: true,
        message: ''
    }

]

function ForgotPassword(props: any) {
    const history: any = useHistory();
    const classes = useStyles()
    const [email, setEmail] = React.useState<any>('')
    const [formGroupData, setFormgroup] = React.useState<any>(formGroup)
    const validateForm = (dataToValidate: any) => {
        let formgroupCopy = [...formGroupData];

        function validateRegexEmail(email: any) {
            // eslint-disable-next-line
            const re: any = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        }

        if (dataToValidate.property === 'email') {
            if (dataToValidate.value === '') {
                formgroupCopy.forEach((formG: any) => {
                    if (formG.field === 'email') {
                        formG.valid = false;
                        formG.message = 'Email should not be empty';
                    }
                })
                setFormgroup(formgroupCopy)
            } else if (dataToValidate.value !== '' && !validateRegexEmail(dataToValidate.value)) {
                formgroupCopy.forEach((formG: any) => {
                    if (formG.field === 'email') {
                        formG.valid = false;
                        formG.message = 'Please provide valid email address'
                    }
                })
                setFormgroup(formgroupCopy)
            } else {
                formgroupCopy.forEach((formG: any) => {
                    if (formG.field === 'email') {
                        formG.valid = true;
                        formG.message = ''
                    }
                })
                setFormgroup(formgroupCopy)
            }
        }



    }

    const handleEmail = (e: any) => {
        e.preventDefault();
        setEmail(e.target.value)
        validateForm({ property: 'email', value: e.target.value })
    }
    const onSubmitForm = (e: any) => {
        e.preventDefault()
        validateForm({ property: 'email', value: email })
        const data = {
            "email": email
        }
        if (email) {
            axiosInstance.post('/forgot-password', data).then((res) => {
                if (res.data) {
                    props.popUpAlert(res.data.message, "UPDATE_AGENT_SUCCESS", "success");
                    history.push('/')
                  
                    history.push('/')
                }
                else {
                    props.popUpAlert(res.data.message, "UPDATE_AGENT_FAIL", "error");
                }
            }).catch((err) => {
                // console.log(err)
                props.popUpAlert(err.response.data.message, "UPDATE_AGENT_FAIL", "error");
            })
        }
    }
    return (

        <div className="sign_wrapper">
            <div >
                <Typography className={classes.mainHeader}>Forget Password ?</Typography>
            </div>
            <Typography className={classes.reset}>You can Reset your Password here</Typography>
            <div className="sign_form_container">
                <form>
                    <div className={classes.divFlex}>
                        <Typography className={classes.email}>Email:</Typography>
                        <TextField
                            type="text"
                            variant="outlined"
                            name="email"
                            id="email"
                            fullWidth
                            size="small"
                            className={classes.emailText}
                            placeholder="Enter your Email"
                            value={email}
                            onChange={handleEmail}
                        />
                    </div>
                    <div style={{ marginLeft: "65px" }}>
                        <p className={classes.error}>{formGroupData.map((fileds: any) => {
                            if (fileds.valid === false && fileds.field === 'email') {
                                return fileds.message
                            } else {
                                return ''
                            }
                        })}
                        </p>
                    </div>


                    <div className={classes.buttons}>
                        <Button type="submit" size="small"
                            className={classes.submitButton} onClick={onSubmitForm} >
                            Submit</Button>
                        <Button type="submit" size="small" variant="outlined" className={classes.backbutton}
                            onClick={() => history.push('/')}>Back</Button>
                    </div>
                </form>
            </div>
        </div>



    )
}
const mapDispatchToProps = (dipatches: any) => {
    return {
        popUpAlert: (err: any, instance: any, type: any) => dipatches(popUpActionCreator.initglobalPopup(err, instance, type))
    }
}
export default connect(null, mapDispatchToProps)(ForgotPassword)
